// Dùng chung cho trang listing Ăn uống / Vui chơi / Mua sắm
export const LISTING_CLASS = {
  root: 'py-20 max-md:py-15',
  top: 'flex items-end justify-between max-md:flex-col max-md:items-start max-md:gap-5',
  total: 'text-[#919191]',
  list: 'mt-8 grid grid-cols-[repeat(2,1fr)] gap-8 max-md:mt-6 max-md:grid-cols-[repeat(1,1fr)] max-md:gap-6',
  viewMore:
    'btn btn-2 mx-auto mt-11 h-11 w-max cursor-pointer rounded-md bg-[#1d75701a] px-11 text-primary max-md:mt-6',
};
